import moment from 'moment'
import React, { useEffect, Component } from 'react'
import {Button, Card, Col, Drawer, Form, Icon, notification, Row, Table, Select} from 'antd'
import _ from 'lodash'

import {FormUtils as GetAllFormFields} from 'sz-react-utils'
import {hideLoader, showLoader} from '../../modules/actions'
import Request from '../../request'
import {connect} from 'react-redux'
import styles from '../../containers/Desk/counselling/all/styles.less'
import {RightsWrapper} from './utils'
const Option = Select.Option

@Form.create()
class TransferCampus extends Component {
    state={
        visible:true,
        campusData:{},
        inputTypes:{
            fields: [
                {
                    label: 'Current University',
                    key: 'existingUniversity',
                    type: 'text',
                    disabled:true,
                    value:''
                },
                {
                    label: 'New University',
                    showSearch:true,
                    key: 'transferCampusTo',
                    type: 'select',
                    required: true,
                    width: 500,
                    options: [],
                    onChange: v => {
                        this.props.form.setFieldsValue({transferCampusTo: v})
                    }
                },
                {
                    label: 'Choose Operation',
                    key: 'operation',
                    type: 'select',
                    required: true,
                    width: 500,
                    options: ['Move', 'Copy'],
                    onChange: v => {
                        this.props.form.setFieldsValue({operation: v})
                    }
                },
            ]
        }
    }

    handleSubmit = (e) =>{
        e.preventDefault();
        const {form, campusId} = this.props;
        form.validateFieldsAndScroll(async(err,valData)=>{
            let campus = this.state.campusData;
            campus.universityId = valData.transferCampusTo;
            campus.deleted = false;
            delete campus._id;
            let moveCampus = await Request.addCampus(campus);
            if(valData.operation === "Move") {
                let dataToSend = {
                    _id:campus.campusUniversityId,
                    campusId
                }
                let deleteCampus = await Request.deleteCampus(dataToSend);
                if(!moveCampus.error || !deleteCampus.error) {
                    this.onClose()
                    notification.success({
                        message:moveCampus.msg
                    })
                }else {
                    notification.error({
                        message: 'Error Saving',
                        description: moveCampus.msg
                    })
                }
            }else {
                if(!moveCampus.error) {
                    this.onClose();
                    notification.success({
                    message: 'Campus Copied Sucessfully'
                })
                }else {
                    notification.error({
                        message: 'Error Saving',
                        description: moveCampus.msg
                    })
                }
            }
        })
    }


    gettingAllDetails = async()=> {
        const {campusId, universityId, alluniversity} = this.props;
        let inputTypes = this.state.inputTypes;
        alluniversity.map((university)=>{
            inputTypes.fields[1].options.push({
                id:university._id,
                display:university.universityInstitutionName
            })
        })
        let data = await Request.getUniversity(universityId)
        inputTypes.fields[0].value = data.doc.universityInstitutionName
        let campusData = await Request.getCampus(campusId)
        this.setState({inputTypes, oldUniversityId:universityId, campusData:campusData.doc.campus})
    }



    componentDidMount() {
        this.gettingAllDetails()
    }

    onClose = () => {
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    render() {
        let {inputTypes} = this.state
        const {
            form: {getFieldDecorator, getFieldValue}
        } = this.props
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Move Campus
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={800}
                visible={this.state.visible}>
                <Card>
                    <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>
                        <div>
                            <GetAllFormFields
                                inputSchema={inputTypes}
                                getFieldDecorator={getFieldDecorator}
                            />
                        </div>
                        <Row>
                            <Col span={8}/>
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{marginBottom: 10}}
                                    loading={this.props.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8}/>
                        </Row>
                    </Form>
                </Card>
                {/* <Card>
                    {
                    excelFieldArray && excelFieldArray.length ? 
                        <Form onSubmit={this.submitMapingFields} style={{marginTop: 8}}>
                            <table className="ant-table-fixed">
                                <tbody className="ant-table-tbody">
                                    {                                
                                    excelFieldArray.map((field, indexExcelFieldArray) => {
                                            return (
                                                <tr key={indexExcelFieldArray} className="ant-table-row  ant-table-row-hover">
                                                    <th className="ant-table-fixed-columns-in-body ant-table-row-cell-break-word" width="300">{field}</th>
                                                    <td className="ant-table-fixed-columns-in-body ant-table-column-has-actions ant-table-column-has-filters ant-table-column-has-sorters ant-table-row-cell-break-word">
                                                        <Select
                                                            showSearch={true}
                                                            allowClear
                                                            optionFilterProp="children"
                                                            style={{
                                                                width: 214,
                                                                paddingRight: 16,
                                                                paddingLeft: 9
                                                            }}
                                                            placeholder="Select Field"
                                                            onChange={fieldKey => { this.setFieldMaping(field, fieldKey) }}
                                                        >
                                                            {DBFieldsArray.map((val, idn) => {
                                                                return (
                                                                    <Option key={idn} value={val}>
                                                                        {val}
                                                                    </Option>
                                                                )
                                                            })}
                                                        </Select>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>
                            <Row>
                                <Col span={8}/>
                                <Col span={8}>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        style={{marginBottom: 10}}
                                        loading={this.props.loading}>
                                        SAVE
                                    </Button>
                                </Col>
                                <Col span={8}/>
                            </Row>
                        </Form>
                        :null
                    }
                </Card> */}
                {/* <Card>
                    <table className="ant-table-fixed" style={{textAlign: 'center'}}>
                        <thead>
                            <tr className="ant-table-row  ant-table-row-hover">
                                {
                                excelFieldArray && excelFieldArray.length ? 
                                    excelFieldArray.map((field, indexField) => {
                                        return (
                                            <th key={indexField} className="ant-table-fixed-columns-in-body ant-table-row-cell-break-word" width={fieldWidth}>{field}</th>
                                        )
                                    })
                                :null
                                }                                
                            </tr>
                        </thead>
                        <tbody className="ant-table-tbody">
                            {
                            excelDatas && excelDatas.length ? 
                                excelDatas.map((excelData, indexExcel) => {
                                    return (
                                        <tr key={indexExcel} className="ant-table-row  ant-table-row-hover">
                                            {
                                                excelFieldArray && excelFieldArray.length ? 
                                                    excelFieldArray.map((field, indexExcelField) => {
                                                        return (
                                                            <td key={indexExcelField} className="ant-table-fixed-columns-in-body ant-table-column-has-actions ant-table-column-has-filters ant-table-column-has-sorters ant-table-row-cell-break-word">{excelData[field]}</td>
                                                        )
                                                    })
                                                :null
                                            }                                             
                                        </tr>
                                    )
                                })
                                :null
                            }
                        </tbody>
                    </table>
                </Card> */}
            </Drawer>
        )
    }
}


const mapStateToProps = ({global, router}) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TransferCampus)